import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';
import { REMOTE__generation_update_visibility } from '@/state/generation/status/REMOTE__generation_update_visibility';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';

interface PROPS {
  generation: DTO__generation;
}

export function G_HEADER__generations_history_item__button_update_visibility({ generation }: PROPS) {
  const dispatch = use_dispatch();

  /*
   *
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let generation_new = generation.clone();
    generation_new.is_visible = !generation_new.is_visible;

    await dispatch(REMOTE__generation_update_visibility(generation_new));
  }

  /*
   *
   */
  if (generation.is_locked()) return <PLACEHOLDER_BUTTON__bar_6 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="full-6"
      {...{ onClick }}
      className=""
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={generation.is_visible ? ICON__eye_slash_solid : ICON__eye_solid}
    />
  );
}
